import { ProductCard } from './ProductCard';
import { Product } from '../../pages/leasing-store/types';
import { Skeleton } from '../ui/Skeleton';
import { useTranslation } from 'react-i18next';

interface ProductGridProps {
  products: Product[];
  loading?: boolean;
}

export function ProductGrid({ products, loading = false }: ProductGridProps) {
	const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
      {loading
        ? Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300">
              <Skeleton width="100%" height={180} className="mb-5 rounded-lg" />
              <Skeleton width="80%" height={20} className="mb-3" />
              <Skeleton width="60%" height={16} className="mb-3" />
              <Skeleton width="40%" height={16} className="mb-5" />
              <Skeleton width="100%" height={36} />
            </div>
          ))
        : products.map((product) => (
            <div key={product.id} className="h-full">
              <ProductCard {...product} className="h-full flex flex-col" />
            </div>
          ))}
      {!loading && products.length === 0 && (
        <div className="col-span-full text-center py-12">
			  <p className="text-gray-500">{t('store.products.noMatch')}</p>
        </div>
      )}
    </div>
  );
}